// Shared Font Awesome icon registry for Astral components.
// Domain mappings return these semantic names (or an asset path for branded icons),
// never raw Font Awesome classes.
const ASTRAL_ICON_CLASSES = {
  arrowLeft: 'fa-light fa-arrow-left',
  call: 'fa-sharp fa-solid fa-phone',
  check: 'fa-light fa-check',
  chevronDown: 'fa-light fa-chevron-down',
  chevronRight: 'fa-light fa-chevron-right',
  clear: 'fa-sharp fa-solid fa-xmark',
  clearOthers: 'fa-light fa-filter-circle-xmark',
  download: 'fa-light fa-download',
  edit: 'fa-light fa-pen',
  email: 'fa-sharp fa-solid fa-envelope',
  excel: 'fa-light fa-file-excel',
  eye: 'fa-light fa-eye',
  eyeSlash: 'fa-light fa-eye-slash',
  externalLink: 'fa-light fa-square-arrow-up-right',
  file: 'fa-sharp fa-light fa-file',
  imageBroken: 'fa-regular fa-image-slash',
  checkboxChecked: 'fa-light fa-square-check',
  checkboxUnchecked: 'fa-light fa-square',
  lock: 'fa-light fa-lock',
  mail: 'fa-sharp fa-solid fa-envelope',
  pdf: 'fa-sharp fa-light fa-file-pdf',
  plus: 'fa-sharp fa-regular fa-plus',
  print: 'fa-light fa-print',
  question: 'fa-thin fa-circle-question',
  search: 'fa-light fa-magnifying-glass',
  sms: 'fa-light fa-mobile-screen-button',
  trash: 'fa-thin fa-trash-can',
  upload: 'fa-light fa-arrow-down-to-bracket',
} as const;

export type AstralIconName = keyof typeof ASTRAL_ICON_CLASSES;

export function resolveAstralIconClass(icon: string | null | undefined): string | null {
  if (!icon) {
    return null;
  }

  return ASTRAL_ICON_CLASSES[icon as AstralIconName] ?? icon;
}
